export default __webpack_public_path__ + "static/media/about.1112959c.svg";